import { render } from "./PledgeHeader.vue?vue&type=template&id=627cc648"
import script from "./PledgeHeader.vue?vue&type=script&lang=js"
export * from "./PledgeHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__